var scrollToTop = function (container) {
    var backToTopDom = $(container);
    function showScrollToTop() {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            backToTopDom.addClass('d-block');
        } else {
            backToTopDom.removeClass('d-block');
        }
    }

    function backToTop() {
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    }

    window.onscroll = function() {
        showScrollToTop();
    };

    backToTopDom.click(function () {
        backToTop();
    });
};

jQuery(document).ready(function($){
    scrollToTop('#back-to-top');
});